import { Types } from 'mongoose';
import { IAccountOwned } from './account';

export interface IProduct extends IAccountOwned {
  _id: Types.ObjectId;
  name: string;
  description: string;
  price: number;
  pricingModel: PricingModel;
  priceTiers: IPricingTier[];
  shippingCost: number;
  deliveryMechanism: DeliveryMechanism;
  imagesRequired: number;
  isInstantDownload: boolean;
  lengthLongSide: number;
  addOnFor: string | IProduct;
  isConfirmed: boolean;
  isArchived: boolean;
  isPublic: boolean;
  replaces: Types.ObjectId | IProduct;
  scope: ProductScope;
  formSchema: IFormField[];
  content: IProductPageContent;
}

export interface IProductPageContent {
  hasContentPage: boolean;
  content: string;
  slug: string;
  appearsInNav: boolean;
  navTitle: string;
  includeOrderForUpcomingEvents: boolean;
}

export interface IPricingTier {
  minVolume: number;
  maxVolume?: number;
  price: number;
}

export enum DeliveryMechanism {
  Post = 'post',
  Email = 'email',
}

export enum PricingModel {
  Standard = 'standard',
  Tiered = 'tiered',
}

export enum ProductScope {
  Image = 'image',
  Album = 'album',
  Event = 'event',
}

export interface IFormField {
  id: string;
  label: string;
  type: FieldType;
  required: boolean;
  options?: string[];
  placeholder?: string;
}

export enum FieldType {
  Text = 'text',
  Number = 'number',
  Select = 'select',
  Checkbox = 'checkbox',
  TextArea = 'textarea',
}
